<script setup lang="ts">
/* eslint-disable vue/no-v-html */
import type {
  ComponentData,
} from '@/types';
import ComponentGridCells from '@/components/content-blocks/components/component-types/ComponentGridCells.vue';
import ComponentAside from './component-types/ComponentAside.vue';
import ComponentGoals from './component-types/ComponentGoals.vue';
import ComponentImage from './component-types/ComponentImage.vue';
import ComponentLinks from './component-types/ComponentLinks.vue';
import ComponentNote from './component-types/ComponentNote.vue';
import ComponentPerson from './component-types/ComponentPerson.vue';
import ComponentQuote from './component-types/ComponentQuote.vue';
import ComponentText from './component-types/ComponentText.vue';

defineProps<{
  componentData: ComponentData;
}>();
</script>

<template>
  <ComponentAside
    v-if="componentData.type === 'aside'"
    :content="componentData.content"
  />

  <ComponentText
    v-else-if="componentData.type === 'text'"
    :content="componentData.content"
  >
    <template v-if="componentData.notes?.length" #notes>
      <div class="notes">
        <div v-for="(note, index) in componentData.notes" :key="typeof note.content === 'string' ? note.content : index" class="note">
          <div v-html="note.content" />
        </div>
      </div>
    </template>
  </ComponentText>

  <ComponentImage
    v-else-if="componentData.type === 'image'"
    v-bind="componentData.content"
  />

  <ComponentGoals
    v-else-if="componentData.type === 'goals'"
  />

  <ComponentPerson
    v-else-if="componentData.type === 'person'"
    :person="componentData.content"
  />

  <ComponentLinks
    v-else-if="componentData.type === 'links'"
    :title="componentData.content.title"
    :links="componentData.content.links"
  />

  <ComponentNote
    v-else-if="componentData.type === 'note'"
    :title="componentData.content.title"
    :text="componentData.content.text"
  />

  <ComponentQuote
    v-else-if="componentData.type === 'quote'"
    :text="componentData.content"
  />

  <ComponentGridCells
    v-else-if="componentData.type === 'grid-cells'"
    :grid-cells="componentData.content"
  />
</template>

<style lang="scss" scoped>
.notes {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  font-size: 1.4rem;

  h5 {
    font-size: 1.4rem;
    font-family: var(--font-secondary);
  }
}
.note {
  border-top: dotted 0.1rem #000;
  margin-bottom: var(--spacing-l);
  padding-top: var(--spacing-ms);
}
</style>
